<template>
    <div class="pagination">
        <span>Mostrando página {{ currentPage }} de {{ totalPages }}</span>

        <div class="pagination_buttons">
            <button 
                :disabled="currentPage === 1" 
                @click="goToPage(currentPage - 1)"
            >
                Anterior
            </button>
            
            <button
                v-for="page in visiblePagesWithoutEnd"
                :key="page"
                :class="{ active: currentPage === page }"
                @click="goToPage(page)"
            >
                {{ page }}
            </button>
            
            <button 
                v-if="totalPages > maxVisiblePages && currentPage < totalPages - Math.floor(maxVisiblePages / 2)"
                disabled
            >
                ...
            </button>

            <button
                :class="{ active: currentPage === totalPages }"
                @click="goToPage(totalPages)"
            >
                {{ totalPages }}
            </button>
            
            <button 
                :disabled="currentPage === totalPages" 
                @click="goToPage(currentPage + 1)"
            >
                Próximo
            </button>
        </div>
     </div>
  </template>
  
  <script>
  export default {
    props: {
      totalPages: {
        type: Number,
        required: true,
      },
      maxVisiblePages: {
        type: Number,
        default: window.innerWidth < 1024 ? 3 : 5,
      },
      currentPage: {
        type: Number,
        default: 1,
      },
    },
    emits: ['page-selected'],
    computed: {
      visiblePagesWithoutEnd() {
        const pages = [];
        const half = Math.floor(this.maxVisiblePages / 2);
        let start = Math.max(this.currentPage - half, 1);
        let end = Math.min(start + this.maxVisiblePages - 1, this.totalPages);
  
        if (end - start < this.maxVisiblePages - 1) {
          start = Math.max(end - this.maxVisiblePages + 1, 1);
        }
  
        for (let i = start; i < end; i++) {
          pages.push(i);
        }
        return pages;
      },
    },
    methods: {
      goToPage(page) {
        if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
          this.$emit('page-selected', page);
        }
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .pagination {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pagination_buttons{
        display: flex;
        gap: 0.5rem;
    }
    @media(max-width: 768px){
        flex-direction: column;
        gap: 10px;
        .pagination_buttons{
            order: 1;
        }
        span {
            order: 2;
        }
    }
  }
  
  button {
    padding: 0.5rem 1rem;
    border: 1px solid #ccc;
    background-color: white;
    color:  #1d1e34;
    cursor: pointer;
  }
  
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  button.active {
    background-color: #1d1e34;
    color: white;
    font-weight: bold;
  }
  </style>
  